"use strict";exports.__esModule = true;exports.symbol = symbol;function symbol() {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 20 18" id=icon-menu><path d="M1 2h18a1 1 0 000-2H1a1 1 0 000 2zm18 6H1a1 1 0 000 2h18a1 1 0 000-2zM1 16h18a1 1 0 010 2H1a1 1 0 010-2z"></path></symbol>';
}